/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AppGroup;
(function (AppGroup) {
    AppGroup["EMPTY"] = "EMPTY";
    AppGroup["INSTALLED"] = "INSTALLED";
    AppGroup["PENDING"] = "PENDING";
    AppGroup["BUSINESS_SOLUTIONS"] = "BUSINESS_SOLUTIONS";
})(AppGroup = exports.AppGroup || (exports.AppGroup = {}));
var AppType;
(function (AppType) {
    AppType["NONE"] = "NONE";
    AppType["EDITOR"] = "EDITOR";
    AppType["DASHBOARD"] = "DASHBOARD";
    AppType["HYBRID"] = "HYBRID";
})(AppType = exports.AppType || (exports.AppType = {}));
var BusinessModel;
(function (BusinessModel) {
    BusinessModel["None"] = "None";
    BusinessModel["FREEMIUM"] = "FREEMIUM";
    BusinessModel["PREMIUM"] = "PREMIUM";
    BusinessModel["FREE"] = "FREE";
    BusinessModel["WIX_PREMIUM"] = "WIX_PREMIUM";
})(BusinessModel = exports.BusinessModel || (exports.BusinessModel = {}));
var ComponentType;
(function (ComponentType) {
    ComponentType["NONE"] = "NONE";
    ComponentType["STUDIO"] = "STUDIO";
    ComponentType["PLATFORM"] = "PLATFORM";
    ComponentType["WORKER"] = "WORKER";
    ComponentType["DASHBOARD"] = "DASHBOARD";
    ComponentType["WIDGET"] = "WIDGET";
    ComponentType["PAGE"] = "PAGE";
    ComponentType["DASHBOARD_PLATFORM"] = "DASHBOARD_PLATFORM";
    ComponentType["STUDIO_WIDGET"] = "STUDIO_WIDGET";
    ComponentType["EMBEDDED_SCRIPT"] = "EMBEDDED_SCRIPT";
    ComponentType["EXTENSION"] = "EXTENSION";
    ComponentType["SNIPPET_SOLUTION"] = "SNIPPET_SOLUTION";
    ComponentType["DATA_COMPONENT"] = "DATA_COMPONENT";
    ComponentType["WEB"] = "WEB";
    ComponentType["DC_CONFIG"] = "DC_CONFIG";
    ComponentType["WIDGET_OUT_OF_IFRAME"] = "WIDGET_OUT_OF_IFRAME";
    ComponentType["PAGE_OUT_OF_IFRAME"] = "PAGE_OUT_OF_IFRAME";
    ComponentType["STATIC_FILE"] = "STATIC_FILE";
    ComponentType["APP_CONFIG"] = "APP_CONFIG";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var EmbedCategory;
(function (EmbedCategory) {
    EmbedCategory["UNKNOWN"] = "UNKNOWN";
    EmbedCategory["ESSENTIAL"] = "ESSENTIAL";
    EmbedCategory["FUNCTIONAL"] = "FUNCTIONAL";
    EmbedCategory["ANALYTICS"] = "ANALYTICS";
    EmbedCategory["ADVERTISING"] = "ADVERTISING";
})(EmbedCategory = exports.EmbedCategory || (exports.EmbedCategory = {}));
var EmbeddedScriptPages;
(function (EmbeddedScriptPages) {
    EmbeddedScriptPages["NONE_PAGES"] = "NONE_PAGES";
    EmbeddedScriptPages["ONCE"] = "ONCE";
    EmbeddedScriptPages["SPECIFIC_PAGES"] = "SPECIFIC_PAGES";
})(EmbeddedScriptPages = exports.EmbeddedScriptPages || (exports.EmbeddedScriptPages = {}));
var EmbeddedScriptPlacement;
(function (EmbeddedScriptPlacement) {
    EmbeddedScriptPlacement["NONE_PLACEMENT"] = "NONE_PLACEMENT";
    EmbeddedScriptPlacement["HEAD"] = "HEAD";
    EmbeddedScriptPlacement["BODY_START"] = "BODY_START";
    EmbeddedScriptPlacement["BODY_END"] = "BODY_END";
})(EmbeddedScriptPlacement = exports.EmbeddedScriptPlacement || (exports.EmbeddedScriptPlacement = {}));
var ExtensionType;
(function (ExtensionType) {
    ExtensionType["NONE_EXTENSION"] = "NONE_EXTENSION";
    ExtensionType["PAYMENTS_GATEWAY_EXTENSION"] = "PAYMENTS_GATEWAY_EXTENSION";
    ExtensionType["COUPONS_EXTENSION"] = "COUPONS_EXTENSION";
    ExtensionType["DROPSHIPPING_EXTENSION"] = "DROPSHIPPING_EXTENSION";
    ExtensionType["FULFILMENT_EXTENSION"] = "FULFILMENT_EXTENSION";
    ExtensionType["DROPSHIPPING_SUPPLIER_EXTENSION"] = "DROPSHIPPING_SUPPLIER_EXTENSION";
    ExtensionType["FULFILLMENT_CENTER_EXTENSION"] = "FULFILLMENT_CENTER_EXTENSION";
    ExtensionType["RESTAURANTS_POS_EXTENSION"] = "RESTAURANTS_POS_EXTENSION";
    ExtensionType["ART_STORE_EXTENSION"] = "ART_STORE_EXTENSION";
    ExtensionType["ASCEND_AUTOMATION_EXTENSION"] = "ASCEND_AUTOMATION_EXTENSION";
})(ExtensionType = exports.ExtensionType || (exports.ExtensionType = {}));
var MediaType;
(function (MediaType) {
    MediaType["VIDEO"] = "VIDEO";
    MediaType["IMAGE"] = "IMAGE";
    MediaType["YOUTUBE"] = "YOUTUBE";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
var OpenConsentIn;
(function (OpenConsentIn) {
    OpenConsentIn["NONE_VALUE"] = "NONE_VALUE";
    OpenConsentIn["NEW_WINDOW"] = "NEW_WINDOW";
    OpenConsentIn["NEW_TAB"] = "NEW_TAB";
})(OpenConsentIn = exports.OpenConsentIn || (exports.OpenConsentIn = {}));
var Order;
(function (Order) {
    Order["NONE_ORDER"] = "NONE_ORDER";
    Order["MOST_POPULAR"] = "MOST_POPULAR";
    Order["GEO"] = "GEO";
})(Order = exports.Order || (exports.Order = {}));
var PlatformType;
(function (PlatformType) {
    PlatformType["NONE_PLATFORM"] = "NONE_PLATFORM";
    PlatformType["EDITOR_PLATFORM"] = "EDITOR_PLATFORM";
    PlatformType["STAND_ALONE_PLATFORM"] = "STAND_ALONE_PLATFORM";
    PlatformType["BUSINESS_MANAGER_PLATFORM"] = "BUSINESS_MANAGER_PLATFORM";
    PlatformType["WIX_INTERNAL"] = "WIX_INTERNAL";
})(PlatformType = exports.PlatformType || (exports.PlatformType = {}));
var Region;
(function (Region) {
    Region["no_region"] = "no_region";
    Region["header"] = "header";
    Region["pageContainer"] = "pageContainer";
    Region["footer"] = "footer";
})(Region = exports.Region || (exports.Region = {}));
var RenewalType;
(function (RenewalType) {
    RenewalType["UNKNOWN"] = "UNKNOWN";
    RenewalType["AUTO_RENEW_ON"] = "AUTO_RENEW_ON";
    RenewalType["AUTO_RENEW_OFF"] = "AUTO_RENEW_OFF";
    RenewalType["MANUAL"] = "MANUAL";
})(RenewalType = exports.RenewalType || (exports.RenewalType = {}));
var TagType;
(function (TagType) {
    TagType["NONE_TAG"] = "NONE_TAG";
    TagType["CATEGORY"] = "CATEGORY";
    TagType["COLLECTION"] = "COLLECTION";
})(TagType = exports.TagType || (exports.TagType = {}));
var Type;
(function (Type) {
    Type["NONE_TYPE"] = "NONE_TYPE";
    Type["APP"] = "APP";
    Type["TEMPLATE"] = "TEMPLATE";
})(Type = exports.Type || (exports.Type = {}));
var UninstallActions;
(function (UninstallActions) {
    UninstallActions["NONE_ACTION"] = "NONE_ACTION";
    UninstallActions["NO_ACTION"] = "NO_ACTION";
    UninstallActions["REMOVE_ALL_PRODUCT"] = "REMOVE_ALL_PRODUCT";
})(UninstallActions = exports.UninstallActions || (exports.UninstallActions = {}));
var WidgetHorizontal;
(function (WidgetHorizontal) {
    WidgetHorizontal["NONE_HORIZONTAL"] = "NONE_HORIZONTAL";
    WidgetHorizontal["LEFT"] = "LEFT";
    WidgetHorizontal["CENTER_HORIZONTAL"] = "CENTER_HORIZONTAL";
    WidgetHorizontal["RIGHT"] = "RIGHT";
})(WidgetHorizontal = exports.WidgetHorizontal || (exports.WidgetHorizontal = {}));
var WidgetVertical;
(function (WidgetVertical) {
    WidgetVertical["NONE_VERTICAL"] = "NONE_VERTICAL";
    WidgetVertical["TOP"] = "TOP";
    WidgetVertical["CENTER_VERTICAL"] = "CENTER_VERTICAL";
    WidgetVertical["BOTTOM"] = "BOTTOM";
})(WidgetVertical = exports.WidgetVertical || (exports.WidgetVertical = {}));
var WidgetWidthType;
(function (WidgetWidthType) {
    WidgetWidthType["NONE_TYPE"] = "NONE_TYPE";
    WidgetWidthType["CUSTOM"] = "CUSTOM";
    WidgetWidthType["FULL"] = "FULL";
})(WidgetWidthType = exports.WidgetWidthType || (exports.WidgetWidthType = {}));
